module.exports = __webpack_public_path__ + "static/media/notfound.ebd53234.png";